import {useSearchParams} from 'react-router-dom';
import CreateRecordStep from './CreateRecordStep';
import SelectDoctorStep from "./SelectDoctorStep/SelectDoctorStep";
import SelectDateTimeStep from "./SelectDateTimeStep/SelectDateTimeStep";

function RecordPage() {
    const [searchParams] = useSearchParams();
    const isHasDoctorId = searchParams.get('doctor_id');
    const doctorId = isHasDoctorId ? Number(isHasDoctorId) : undefined;

    const isHasStart = searchParams.get('start');
    const start = isHasStart ? isHasStart : undefined;

    const isHasEnd = searchParams.get('end');
    const end = isHasEnd ? isHasEnd : undefined;

    return (
        <>
            {!doctorId ? (
                <SelectDoctorStep/>
            ) : !isHasStart && !isHasEnd ? (
                <SelectDateTimeStep doctorId={doctorId}/>
            ) : (
                <CreateRecordStep doctorId={doctorId} {...{start, end} as any}/>
            )}
        </>
    );
}

export default RecordPage;
